import { Typography } from '@material-ui/core'
import { TextStyles } from 'utils/text'

import { Card } from 'modules/ui'

export const EmptyOrderProducts = () => (
  <Card title="Productos" withShadow>
    <div className="p-l-24">
      <Typography {...TextStyles.subtitle2Dark()}>
        No existen productos para este cliente
      </Typography>
    </div>
  </Card>
)
